<template>
    <div class="row">
	    <VeeForm :validation-schema="checkoutValidationSchema" :initial-values="initialValues" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div">
            <form ref="form" @submit="handleSubmit($event, onCheckoutSubmit)" method="post" :action="this.baseUrl + '/process-order'" class="row">
                <div class="col-12 col-lg-8">
                    <div class="row">
                        <div class="col-12">
                            <billing-details
                                :basket="basket"
                                :registration="sessionReg"
                                :postcode="sessionPostcode"
                                :addresses="billingAddresses"
                                :errors="errors"
                                :custom-validation-message="customValidationMessage"
                                @inputAddressManually="inputAddressManually = !inputAddressManually"
                            ></billing-details>
                        </div>
                        <div class="col-12 mt-3" v-if="fitter?.mobile == 1 || basket?.home_delivery == 1">
                            <address-details
                                :fitter="fitter"
                                :postcode="sessionPostcode"
                                :addresses="shippingAddresses"
                                :same-as-billing="this.same_as_billing"
                                :errors="errors"
                                @inputShippingAddressManually="inputShippingAddressManually = !inputShippingAddressManually"
                                @toggleShippingFields="this.same_as_billing = !this.same_as_billing;"
                            ></address-details>
                        </div>
                        <div class="col-12 mb-0 mb-2 mb-lg-0 mt-3" v-if="fitter">
                            <fitting-details
                                :basket-app-date="basket.app_date"
                                :basket-app-time="basket.app_time"
                                :basket-app-end-time="basket.app_end_time"
                                :fitter="fitter"
                                :postcode-details="postcodeDetails"
                                :google-maps-api-key="googleMapsApiKey"
                                :errors="errors"
                                :custom-slot-count="customSlotCount"
                                :mobile-fitting-slots="mobileFittingSlots"
                                :totd-fitting-slots="totdFittingSlots"
                                :show-order-in-next="showOrderInNext"
                            ></fitting-details>
                            <Field v-if="validateAppDate" as="hidden" name="validateAppDate" :value="validateAppDate"></Field>
                            <Field v-if="validateAppTime" as="hidden" name="validateAppTime" :value="validateAppTime"></Field>
                        </div>
                        <div class="col-12 mt-3" v-if="fitterServices?.available?.length > 0">
                            <extras :services="fitterServices" :basket="updatedBasket"></extras>
                        </div>
                        <div class="col-12 mt-3">
                            <enter-discount></enter-discount>
                        </div>
                        <div class="col-12 mt-3" v-if="customValidationMessage.ENABLED">
                            <div class="card rounded-16">
                                <div class="card-header bg-grey p-2 d-flex align-items-center gap-2 rounded-top">
                                    <b class="text-16">Uber activity</b>
                                </div>
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <span>Are you an active Uber driver?</span>
                                        <Popper
                                            :content="errors.uber_driver"
                                            arrow
                                            placement="top"
                                            class="m-0 border-0 ms-3"
                                            :show="!!errors.uber_driver"
                                        >
                                            <div class="d-flex align-items-center gap-3">
                                                <label class="mb-0 cursor-pointer">
                                                    <Field
                                                        name="uber_driver"
                                                        type="radio"
                                                        :value="true"
                                                        class="me-1 cursor-pointer"
                                                    />
                                                    Yes
                                                </label>

                                                <label class="mb-0 cursor-pointer">
                                                    <Field
                                                        name="uber_driver"
                                                        type="radio"
                                                        :value="false"
                                                        class="me-1 cursor-pointer"
                                                    />
                                                    No
                                                </label>
                                            </div>
                                        </Popper>
                                    </div>
                                    <div class="d-flex align-items-center mt-3">
                                        <span>Have you accepted trips with Uber in the last 90 days?</span>
                                        <Popper
                                            :content="errors.uber_trips"
                                            arrow
                                            placement="top"
                                            class="m-0 border-0 ms-3"
                                            :show="!!errors.uber_trips"
                                        >
                                            <div class="d-flex align-items-center gap-3">
                                                <label class="mb-0 cursor-pointer">
                                                    <Field
                                                        name="uber_trips"
                                                        type="radio"
                                                        :value="true"
                                                        class="me-1 cursor-pointer"
                                                    />
                                                    Yes
                                                </label>

                                                <label class="mb-0 cursor-pointer">
                                                    <Field
                                                        name="uber_trips"
                                                        type="radio"
                                                        :value="false"
                                                        class="me-1 cursor-pointer"
                                                    />
                                                    No
                                                </label>
                                            </div>
                                        </Popper>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <div class="card rounded-16">
                                <div class="card-header bg-grey p-2 d-flex align-items-center gap-2 rounded-top">
                                    <b class="text-16">Payment</b>
                                </div>
                                <div class="card-body">
                                    <span class="fa-preload" data-fa-detect-icon>
                                        <i class="fa-light fa-square fa-xl"></i>
                                        <i class="fa-light fa-square-check fa-xl"></i>
                                    </span>
                                    <label
                                        for="agreed_conditions"
                                        class="terms-label d-inline-block cursor-pointer my-2"
                                        :class="{'active': agreedTerms}"
                                        @click="toggleAgreedTerms"
                                    >
                                        <Popper :content="errors.agreed_conditions" arrow placement="top" class="w-100 m-0 border-0" :show="!!errors.agreed_conditions">
                                            <div>
                                                <i
                                                    class="fa-xl fa-light mt-0 mt-sm-3 me-2"
                                                    :class="agreedTerms ? 'fa-square-check' : 'fa-square'"
                                                ></i>
                                                I have read and accept the <a :href="this.baseUrl + '/terms'" title="Terms & Conditions" class="text-primary" target="_blank">terms and conditions</a>
                                            </div>
                                        </Popper>
                                    </label>
                                    <Field id="agreed_conditions" name="agreed_conditions" type="checkbox" class="d-none"/>
                                    <div class="payment-options d-flex flex-column col-12 col-lg-6 mt-2">
                                        <Field id="payment_method" as="hidden" name="payment_method" v-model="this.paymentMethod" />
                                        <div class="payment-options d-block text-center">
                                            <img class="card-option" src="/assets/img/footer/visa.svg" alt="Visa Accepted" />
						                    <img class="mx-2 card-option" src="/assets/img/footer/mastercard.svg" alt="Mastercard Accepted" />
						                    <img class="card-option" src="/assets/img/footer/google_pay.svg" alt="Google Pay Accepted" />
                                        </div>
                                        <button data-payment="card" type="submit" class="btn btn-primary form-control my-3 py-2 fs-6">Pay by Card</button>
                                        <!-- <template v-if="payWithAmazon">
                                            <div class="amazonpay-button-container amazonpay-button-enabled amazonpay-button-container-rows mb-3" @click="this.paymentMethod = 'amazon'">
                                                <button name="amazon" data-payment="amazon" type="submit" class="amazonpay-button-view1 amazonpay-button-view1-gold">
                                                    <picture class="amazonpay-button-logo"><img src="https://m.media-amazon.com/images/G/02/AmazonPay/Maxo/logo._CB452516594_.svg"></picture>
                                                </button>
                                                <div class="text-center">
                                                    <button name="amazon" data-payment="amazon" type="submit" class="pt-0 btn amazonpay-button-view3">
                                                        <picture class="amazonpay-button-microtext">
                                                            <img src="https://static-eu.payments-amazon.com/assets/maxo/microtext/en_GB.svg">
                                                        </picture>
                                                    </button>
                                                </div>
                                            </div>
                                        </template> -->
                                        <template v-if="payWithPaypal">
                                            <button data-payment="paypal" data-button-text="" type="submit" name="paypal" class="btn form-control fs-6 paypal-button py-2" @click="this.paymentMethod = 'paypal' ">
                                                <img :src="this.baseUrl + '/assets/img/generic_images/paypal.png'" alt="Paypal" />
                                            </button>
                                            <template v-if="showPaypalBanners">
                                                <div class="pp-banner mt-2" data-pp-message :data-pp-amount="updatedBasket.total" data-pp-placement="payment" data-pp-style-layout="text" data-pp-style-logo-type="inline"></div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                    <div class="sticky-lg-top">
                        <div class="card-header bg-grey p-2 d-flex align-items-center gap-2 rounded-16 mb-3 p-2 justify-content-between" style="border: 1px solid rgba(61, 61, 61, 0.1);">
                            <b class="fs-5">Order total</b>
                            <b class="fs-4">&pound;{{ updatedBasket.total }}</b>
                        </div>
                        <div class="card h-auto rounded-16">
                            <div class="card-header bg-grey p-2 rounded-top">
                                <b>Your total</b>
                            </div>
                            <div class="card-body">
                                <order-details
                                    :basket="updatedBasket"
                                    :services="fitter.services"
                                ></order-details>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </VeeForm>
        <span v-if="payment == 'online'" id="payment-submit" ref="paymentSubmit"></span>
        <div v-if="payment == 'online'" id='payment-fancybox'></div>
        <teleport to="body">
			<service-modal :services="serviceData" :basket="updatedBasket" :tyre-admin-url="tyreAdminUrl" :fuel-env="fuelEnv" :service-modal-open="serviceModalOpen" @closeModal="serviceModalOpen = false"></service-modal>
            <info-modal></info-modal>
		</teleport>
    </div>
</template>
<script>
    import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate';
    import * as yup from 'yup';
    import checkout from '@shared/mixins/checkout';

    export default {
        props: [
            'basket',
            'fitter',
            'sessionReg',
            'sessionPostcode',
            'addresses',
            'websiteUrl',
            'payment',
            'postcodeDetails',
            'googleMapsApiKey',
            'customSlotCount',
            'mobileFittingSlots',
            'totdFittingSlots',
            'payWithPaypal',
            'payWithAmazon',
            'showPaypalBanners',
            'flashData',
            'showOrderInNext',
            'customValidationMessage',
            'fittingType',
            'tyreAdminUrl',
            'fuelEnv'
        ],
        mixins: [checkout],
        components: {
            VeeForm, Field, ErrorMessage
        },
        provide() {
            return {
                flashData: this.flashData
            }
        },
        data() {
            let checkoutValidationSchema = yup.object({
                // Billing/Shipping fields
                forename: yup.string().required('First name is required'),
                surname: yup.string().required('Last name is required'),
                email: yup.string().email().required(this.customValidationMessage.ENABLED ? this.customValidationMessage.MESSAGE : 'Email is required').nullable(),
                telephone: yup.string().required('Telephone is required'),
                registration: yup.string().required('Registration is required').nullable(),
                postcode: yup.string().required('Invalid postcode').nullable(),
                address: yup.string().when(['input_address_manually'], {
                is: (input_address_manually) => input_address_manually != true,
                then: yup.string().required('Address is required'),
                }),
                address1: yup.string()
                .when('input_address_manually', {
                    is: true,
                    then: yup.string().required('Address 1 is required')
                }),
                town: yup.string()
                .when('input_address_manually', {
                    is: true,
                    then: yup.string().required('Town is required')
                }),
                no_mail: yup.number().integer(),
                // Fitting appointment fields
                app_date: yup.string()
                .when('validateAppDate', {
                    is: true,
                    then: yup.string().required()
                }),
                app_time: yup.string()
                .when('validateAppTime', {
                    is: true,
                    then: yup.string().required()
                }),
                // Shipping fields
                shipping_forename: yup.string()
                .when('same_as_billing', {
                    is: 'on',
                    then: yup.string().required('First name is required')
                }),
                shipping_surname: yup.string()
                .when('same_as_billing', {
                    is: 'on',
                    then: yup.string().required('Last name is required')
                }),
                shipping_postcode: yup.string()
                .when('same_as_billing', {
                    is: 'on',
                    then: yup.string().required('Postcode is required')
                }),
                shipping_address: yup.string().when(['same_as_billing', 'input_shipping_address_manually'], {
                is: (same_as_billing, input_shipping_address_manually) => same_as_billing == 'on' && input_shipping_address_manually != true,
                then: yup.string().required('Shipping Address is required'),
                }),
                shipping_address1: yup.string()
                .when('input_shipping_address_manually', {
                    is: true,
                    then: yup.string().required('Address 1 is required')
                }),
                shipping_town: yup.string()
                .when('input_shipping_address_manually', {
                    is: true,
                    then: yup.string().required('Town is required')
                }),
                //Custom Uber fields
                // Make these conditional: required only when customValidationMessage.ENABLED is true
                uber_driver: (this.customValidationMessage && this.customValidationMessage.ENABLED) ? yup.boolean().required('This field is required') : yup.boolean().notRequired().nullable(),
                uber_trips: (this.customValidationMessage && this.customValidationMessage.ENABLED) ? yup.boolean().required('This field is required') : yup.boolean().notRequired().nullable(),
                //Order fields
                agreed_conditions: yup.string().required('You must accept the terms and conditions to continue.')
            });

            return {
                registration: this.sessionReg != null ? this.sessionReg : '',
                postcode: this.sessionPostcode != null ? this.sessionPostcode : '',
                serviceModalOpen: false,
                billingAddresses: this.addresses,
                shippingAddresses: this.addresses,
                inputAddressManually: false,
                inputShippingAddressManually: false,
                //Shipping fields,
                same_as_billing: (this.basket?.home_delivery == 1 || this.fitter?.mobile == 1) ? true : false,
                //Order fields
                agreedTerms: false,
                paymentMethod: 'card',
                checkoutValidationSchema,
                validateAppDate: this.basket?.home_delivery == 0,
                validateAppTime: (this.basket?.home_delivery == 0 && (this.fitter?.mobile == 0 || this.fitter?.cal_account_number == 'CALTOTD')),
                // Pre-fill
                initialValues: {
                    forename: this.basket?.billing_forename || '',
                    surname: this.basket?.billing_surname || '',
                    email: this.basket?.email || '',
                    postcode: this.basket?.billing_postcode || (this.sessionPostcode || ''),
                    address1: this.basket?.billing_address1 || '',
                    address2: this.basket?.billing_address2 || '',
                    address3: this.basket?.billing_address3 || '',
                    town: this.basket?.billing_town || '',
                    county: this.basket?.billing_county || '',
                    telephone: this.basket?.billing_telephone || '',
                    registration: this.sessionReg || '',
                    shipping_title: this.basket?.shipping_title || '',
                    shipping_forename: this.basket?.shipping_forename || '',
                    shipping_surname: this.basket?.shipping_surname || '',
                    shipping_postcode: this.basket?.shipping_postcode || '',
                    shipping_address1: this.basket?.shipping_address1 || '',
                    shipping_address2: this.basket?.shipping_address2 || '',
                    shipping_address3: this.basket?.shipping_address3 || '',
                    shipping_town: this.basket?.shipping_town || '',
                    shipping_county: this.basket?.shipping_county || '',
                    shipping_telephone: this.basket?.shipping_telephone || '',
                    payment_method: this.paymentMethod
                }
            }
        },
        mounted() {
        },
        methods: {
            async postcodeLookup(postcode, billing) {
                let vm = this;
                //There is no point in trying to search for geolocation on less than 3 characters
                if(postcode.length >= 3) {

                    const lookup = await axios.post('/ajax/postcode_addresses/'+ postcode +'.json');

                    if(lookup.length != 0) {
                        if(billing == true) {
                            vm.billingAddresses = lookup.data.response;
                        }
                        else {
                            vm.shippingAddresses = lookup.data.response;
                        }
                    }
                }
            },
            toggleAgreedTerms() {
                this.agreedTerms = !this.agreedTerms;
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            }
        }
    }
</script>
<style lang="scss" scoped>
    .sticky-lg-top {
        top: 10px;
    }
    .terms-link {
        color: #39AAE1;
    }
    .payment-options {
        .card-option {
            height: 32px;
            width: auto;
        }
    }
    .paypal-button {
        padding: 5px;
        background-color: #F7B43F;
        border: 1px solid #F7B43F;
    }
    .amazonpay-button-container {
		-webkit-text-size-adjust: 100%;
		-webkit-tap-highlight-color: transparent;
		line-height: 1.42857143;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-family: Montserrat,sans serif,serif!important;
		font-weight: 400!important;
		color: #383838;
		font-size: 14px!important;
		display: grid;
		justify-items: stretch;
		min-height: 42px;
		min-width: 113px;
		height: 100%;
		width: 100%;
		touch-action: manipulation;
		max-height: 65px;
		left: 0px;
		right: 0px;
		top: 0px;
		bottom: 0px;
		grid-template-rows: 65% 10% 25%;
		cursor: pointer;
		position: relative;
	}	
	.amazonpay-button-view1 {
		all: unset;
		-webkit-text-size-adjust: 100%;
		-webkit-tap-highlight-color: transparent;
		line-height: 1.42857143;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-family: Montserrat,sans serif,serif!important;
		font-weight: 400!important;
		color: #383838;
		font-size: 14px!important;
		cursor: pointer;
		grid-row-start: 1;
		grid-row-end: 2;
		border-radius: 3px;
		box-shadow: 0 1px 0 rgba(255, 255, 255, 0.4) inset;
		border-style: solid;
		border-width: 1px;
		box-sizing: border-box;
		width: 100%;
		display: grid;
		grid-template-rows: 13% 13% 1fr 1fr 10% 16%;
		grid-template-columns: 4% 10% 6% 1fr 6% 10% 4%;
		justify-items: center;
		justify-self: stretch;
		align-self: stretch;
		border-color: #a88734 #9c7e31 #846a29;
		background: linear-gradient(to bottom, #f7dfa5, #f0c14b);
		// position: absolute;
	}
	.amazonpay-button-view1 img {
		text-size-adjust: 100%;
		-webkit-tap-highlight-color: transparent;
		line-height: 1.42857;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizelegibility;
		color: rgb(56, 56, 56);
		font-family: Montserrat, "sans serif", serif !important;
		font-weight: 400 !important;
		font-size: 14px !important;
		cursor: pointer;
		display: block;
		height: 100%;
		width: 100%;
		user-select: none;
		object-fit: contain;	
	}
	.amazonpay-button-logo {
		-webkit-text-size-adjust: 100%;
		-webkit-tap-highlight-color: transparent;
		line-height: 1.42857143;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-family: Montserrat,sans serif,serif!important;
		font-weight: 400!important;
		color: #383838;
		font-size: 14px!important;
		cursor: pointer;
		grid-row-start: 3;
		grid-row-end: 6;
		grid-column-start: 4;
		grid-column-end: 5;
	}
	.amazonpay-button-chevrons {
		-webkit-text-size-adjust: 100%;
		-webkit-tap-highlight-color: transparent;
		line-height: 1.42857143;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-family: Montserrat,sans serif,serif!important;
		font-weight: 400!important;
		color: #383838;
		font-size: 14px!important;
		cursor: pointer;
		grid-row-start: 3;
		grid-row-end: 5;
		grid-column-start: 6;
		grid-column-end: 7;
	}
    .amazonpay-button-microtext img {
        max-width: 200px;
    }

    .terms-label {
        input {
            display: none;
        }
    }
    .fa-preload {
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
        opacity: 0;
        pointer-events: none;
    }
</style>